/**
 * アクティベート（招待）
 */
import * as httpConst from '../../../../constants/httpConst'
import Vue from 'vue'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/tenants/configuration`

/**
 * 各種利用有無
 * @property use_allocate 配車利用有無
 * @property use_ec_contract 電子契約利用有無
 * @property use_billing 請求利用有無
 * @property use_slip_print 伝票利用有無
 * @property mode 利用モード
 * @property use_demo デモ利用有無
 * @property use_freee_claim freee請求連携
 * @property use_jw_mode JWモード利用有無
 * @property use_jwnet_transfer JWNETデータ取込利用有無
 * @property use_trial_plan お試しプランか否か
 * @property use_ec_contract_single_plan 電子契約単体プランか否か
 * @property use_proxy_entry 他社運搬機能利用有無
 * @property use_recycling 再資源法令適用有無
 */
const getDefaultState = () => {
  return {
    use_allocate: true,
    use_ec_contract: true,
    use_billing: true,
    use_slip_print: true,
    mode: 'transport',
    use_demo: true,
    use_freee_claim: false,
    use_jw_mode: true,
    use_jwnet_transfer: true,
    use_trial_plan: false,
    use_ec_contract_single_plan: false,
    use_proxy_entry: false,
    use_recycling: false,
    transport_day: 0,
    disposal_day: 0,
    final_disposal_day: 0,
  }
}

const tenant_configuration = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    /**
     * 配車計画の利用設定
     * @param state
     * @return {boolean|*}
     */
    enableAllocate: ( state ) => {
      return (state.use_allocate) || false
    },
  },
  actions: {
    show ({ commit }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          let content = data.content
          commit(types.DRIVER_TENANT_CONFIGURATION, { content })
          resolve(content)
        })
      })
    },
    updateConfiguration ({ commit }, { tenant }) {
      return new Promise((resolve) => {
        commit(types.DRIVER_TENANT_CONFIGURATION, { content: tenant })
        resolve()
      })
    },
  },
  mutations: {
    [types.DRIVER_TENANT_CONFIGURATION] (state, { content }) {
      state.use_allocate = content.use_allocate
      state.use_ec_contract = content.use_ec_contract
      state.use_billing = content.use_billing
      state.use_slip_print = content.use_slip_print
      state.mode = content.mode
      state.use_demo = content.use_demo
      state.use_freee_claim = content.use_freee_claim
      state.use_jw_mode = content.use_jw_mode
      state.use_jwnet_transfer = content.use_jwnet_transfer
      state.use_trial_plan = content.use_trial_plan
      state.use_ec_contract_single_plan = content.use_ec_contract_single_plan
      state.use_proxy_entry = content.use_proxy_entry
      state.use_recycling = content.use_recycling
      state.transport_day = content.transport_day
      state.disposal_day = content.disposal_day
      state.final_disposal_day = content.final_disposal_day
    },
  },

}

export default tenant_configuration
